export const STRING_MIN_LENGTH_DEFAULT = 1;
export const STRING_MAX_LENGTH_DEFAULT = 64;
export const APP_HEADER_HEIGHT = 50;
export const PORT_MIN = 1;
export const PORT_MAX = 65000;

// Quote throttling interval, in ms (servers and core symbols share the bounds and the BE default)
export const MIN_THROTTLING_INTERVAL = 100;
export const MAX_THROTTLING_INTERVAL = 10000;
export const DEFAULT_THROTTLING_INTERVAL = 100;

export const APP_MIN_WIDTH = 1500;
export const APP_MIN_HEIGHT = 600;
